import { useTheme } from '@qse/ui'
import { Outlet } from 'react-router-dom'

const AuthLayout = () => {
  const { theme } = useTheme()

  return (
    <div className=" grid md:grid-cols-2 grid-cols-1 md:overflow-hidden">
      <div className="md:block h-screen hidden col-span-1 bg-blue-600 dark:bg-[#4793EB] relative">
        <div className="flex justify-center items-center h-full   w-full">
          {theme === 'light' ? (
            <img alt="logo" className="w-full" src={'/assets/svg/logo-light.svg'} />
          ) : (
            <img alt="logo" className="w-full" src={'/assets/svg/bg-logo-auth-2.svg'} />
          )}
        </div>
        <div className="absolute bottom-0 pb-10 left-0 w-full h-full flex justify-center items-end">
          <h2 className="text-white dark:text-white text-[28px] font-medium">Drive</h2>
        </div>
      </div>

      <div className="col-span-1 h-screen overflow-y-scroll scrollbar-hide bg-white dark:bg-black text-gray-900 dark:text-white">
        <Outlet />
      </div>
    </div>
  )
}

export default AuthLayout
